/**
 * External dependencies
 */
import React, { useState } from "react";
import { connect } from "react-redux";
import page from "page";

/**
 * Internal dependencies
 */
import DropdownLink from "components/dropdown-link";
import {
  addWidgetToLayout,
  removeReportFromLayout,
  saveEditedLayout,
} from "state/dashboard-layouts/actions";
import { getLayoutId } from "state/dashboard/selectors";
import { deleteReport } from "state/reports/actions";
import { startEditing as startRenameReport } from "state/ui/report-rename-form/actions";
import { successNotice, errorNotice } from "state/notices/actions";

const RowAction = ({ report, currentDashboardId, ...props }) => {
  const [isPerformingAction, setIsPerformingAction] = useState(false);

  if (!report) {
    return null;
  }

  let actions = [];

  if (report.template === "custom") {
    actions.push({
      key: "edit",
      label: "Edit",
      onClick: () => page(`/report-builder/${report.id}/edit`),
    });
  }

  if (!report.inDashboard) {
    actions.push({
      key: "add_dashboard",
      label: "Add to deck",
      onClick: async () => {
        setIsPerformingAction(true);
        try {
          props.addWidgetToLayout(currentDashboardId, report.id);
          await props.saveEditedLayout(currentDashboardId);
          props.successNotice("Report has been added to your deck.");
        } catch (error) {
          props.errorNotice("Failed to add report to your deck.");
        }
        setIsPerformingAction(false);
      },
    });
  } else {
    actions.push({
      key: "remove_dashboard",
      label: "Remove from deck",
      onClick: async () => {
        setIsPerformingAction(true);
        try {
          props.removeReportFromLayout(currentDashboardId, report.id);
          await props.saveEditedLayout(currentDashboardId);
          props.successNotice("Report has been removed from your deck.");
        } catch (error) {
          console.log(error);
        }
        setIsPerformingAction(false);
      },
    });
  }

  actions.push({
    key: "rename",
    label: "Rename",
    onClick: () => props.startRenameReport(report.id),
  });

  actions.push({
    key: "delete",
    label: "Delete",
    onClick: () =>
      props.deleteReport(report.id).catch((err) => console.log(err)),
  });

  return (
    <DropdownLink
      disabled={isPerformingAction}
      title="actions"
      items={actions}
    ></DropdownLink>
  );
};

export default connect(
  (state) => ({
    currentDashboardId: getLayoutId(state),
  }),
  {
    successNotice,
    errorNotice,
    removeReportFromLayout,
    addWidgetToLayout,
    deleteReport,
    startRenameReport,
    saveEditedLayout,
  }
)(RowAction);
